import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { QuotaPreferenceService } from '@Admin/AccountManagement/services/quota-preference.service';

import { MonitoringConfigsModel } from '../../models/monitoring.configs.model';
import { AccountManagementService } from '../../services/account-management.service';

@Component({
    selector: 'agpr-unsaved-export-preferences',
    templateUrl: './unsaved-export-preferences.component.html',
    styleUrls: ['./unsaved-export-preferences.component.scss'],
    standalone: false
})
export class UnsavedExportPreferencesComponent implements OnInit, OnDestroy {


    showQuotaBanner$: Observable<boolean> = this.quotaPreferenceService.showQuotaBanner$;
    unsavedMentionExportLimit: number = 50000;

    private monitoringConfigs: MonitoringConfigsModel;
    private subscriptions: Subscription[] = [];

    readonly messageSeverityEnum = messageSeverityEnum;

    constructor(
        private accountManagementService: AccountManagementService,
        private quotaPreferenceService: QuotaPreferenceService,
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.accountManagementService.getMonitoringConfig().subscribe((config) => {
                this.monitoringConfigs = config;
                this.unsavedMentionExportLimit = this.monitoringConfigs.unsavedMentionExportLimit;
            }),
        );
    }

    checkUnsavedMentionExportLimit() {
        if (this.unsavedMentionExportLimit === null || this.unsavedMentionExportLimit === undefined) {
            this.unsavedMentionExportLimit = this.monitoringConfigs.unsavedMentionExportLimit;
        } else {
            this.monitoringConfigs.unsavedMentionExportLimit = this.unsavedMentionExportLimit;
        }
    }

    ngOnDestroy() {
        this.subscriptions?.forEach(subscription => subscription.unsubscribe());
        this.showQuotaBanner$ = null;
    }
}
